export const calendarConstants = {
  LOAD: 'PROMO_CALENDAR_WINTER_STATUS_LOAD',
  LOADING: 'PROMO_CALENDAR_WINTER_STATUS_LOADING',
  LOADED: 'PROMO_CALENDAR_WINTER_STATUS_LOADED',

  OPEN_PRIZE: 'PROMO_CALENDAR_WINTER_OPEN_PRIZE',
  COLLECT_PRIZE: 'PROMO_CALENDAR_WINTER_COLLECT_PRIZE',
};

